import { Box, Flex, Text, Button } from "@chakra-ui/react";
import { FaScrewdriverWrench, FaTreeCity, FaPenRuler} from "react-icons/fa6";
import image1 from "../images/image1.png";
import image2 from "../images/image2.png";
import image3 from "../images/image5.png";
import image4 from "../images/image3.png";
import image5 from "../images/image4.png";
import Header from "../utils/header";
import Footer from "../utils/footer";
import { ServiceCard, ChangeText, ImageCarousel, AnimatedComponent} from "../utils/utils"; 

const texts = [
  {"texts":[
    {"data":"Membangun dengan","size":{"base":"3xl","md":"5xl","lg":"6xl"},"color":"white","weight":"bold","mb":1},
    {"data":"Integritas","size":{"base":"4xl","md":"6xl","lg":"7xl"},"color":"yellow","weight":"bolder","mb":20},
    {"data":"Kami memberikan solusi konstruksi berkualitas yang tahan lama","size":"sm","color":"white","weight":"normal"},
  ]},
  {"texts":[
    {"data":"Inovasi","size":{"base":"3xl","md":"5xl","lg":"6xl"},"color":"white","weight":"bold","mb":1},
    {"data":"Infrastruktur","size":{"base":"4xl","md":"6xl","lg":"7xl"},"color":"orange.400","weight":"bolder","mb":20},
    {"data":"Menggabungkan teknologi modern dengan rekayasa yang terbukti untuk menciptakan proyek yang lebih cerdas dan lebih kuat","size":"sm","color":"white","weight":"normal"},
  ]},
  {"texts":[
    {"data":"Keamanan, Kualitas","size":{"base":"3xl","md":"5xl","lg":"6xl"},"color":"white","weight":"bold","mb":1},
    {"data":"Keunggulan","size":{"base":"4xl","md":"6xl","lg":"7xl"},"color":"green.300","weight":"bolder","mb":20},
    {"data":"Operasi yang aman, kualitas tanpa kompromi, dan hasil yang luar biasa setiap saat","size":"sm","color":"white","weight":"normal"},
  ]}
]

const texts_about = [
  {"data":"Profesional","color":"orange.400","weight":"bolder"},
  {"data":"Terpercaya","color":"yellow.400","weight":"bolder"},
  {"data":"Inovatif","color":"green.400","weight":"bolder"},
  {"data":"Handal","color":"blue.400","weight":"bolder"},
  {"data":"Berpengalaman","color":"yellow.400","weight":"bolder"},
  {"data":"Kredibel","color":"blue.400","weight":"bolder"},
]

const Home = () => {
  return (
    <Box bg="#F5F5F5" minH="100vh">
      <Header/>
      {/* Hero Section */}
      <ImageCarousel images={[
        {"data":image1,"link":(<a href="https://www.freepik.com/free-photo/construction-worker-engineer-working-together-construction-site_25830783.htm">Image by partystock on Freepik</a>)},
        {"data":image2,"link":(<a href="https://www.freepik.com/free-photo/manager-meeting-with-engineer-outdoor-site-stack-hand-teamwork_26330567.htm">Image by Wiroj Sidhisoradej on Freepik</a>)},
        {"data":image3,"link":(<a href="https://www.freepik.com/free-photo/building-new-concrete-houses_1473974.htm">Image by bearfotos on Freepik</a>)}]} texts={texts} imagesOnMobile={[image2,image4,image5]}/>

      {/* About Section */}
      <Box py={20} px={4} bgGradient="to-tl" gradientFrom="green.950" gradientTo="green.800">
        <AnimatedComponent delay={0}>
            <Flex spaceX={4}>
              <Text
                fontSize={{"base":"2xl","md":"4xl"}} 
                fontWeight="bold" 
                textAlign="center" 
                color="#d0d0d0ff"
              >
                Kami
              </Text>
              <ChangeText texts={texts_about} size={{"base":"2xl","md":"4xl"}} sizeRoot={{"base":"3xl","md":"5xl"}}></ChangeText>
            </Flex>
          </AnimatedComponent>
          <Text color="white" textStyle="">
            Kami adalah perusahaan jasa konstruksi yang berlandaskan nilai-nilai keikhlasan dan kejujuran. 
            Kami hadir sebagai mitra terpercaya dalam membangun hunian, bangunan pendidikan, masjid, dan berbagai fasilitas umum
            dengan kualitas yang tinggi dan penuh tanggung jawab
          </Text>
      </Box>

      {/* Services Section */}
      <Box bgImage={`url(${image4})`}>
        <Box bgColor="whiteAlpha.900" py={16} px={4}>
          <AnimatedComponent delay={0}>
            <Text
              fontSize="4xl" 
              fontWeight="bold" 
              textAlign="center" 
              mb={10}
              color="#143979ff"
            >
              Pelayanan Kami
            </Text>
          </AnimatedComponent>
          <Flex 
            maxW="8xl" 
            mx="auto" 
            flexDir={{ base: "column", md: "row" }} 
            justifyContent="space-around"
            align="center"
            gap={8}
          >
            <ServiceCard
              title="Renovasi/Perbaikan" 
              icon={<FaScrewdriverWrench />} 
              colors={["blue.500","#88ddf0ff"]}
              description="Meningkatkan kualitas bangunan Anda dengan perbaikan tepat, rapi, dan hasil yang tahan lama."
              link="/service#renovasi"
              delay={0}
              is_main={false}
            />
            <ServiceCard 
              title="Konstruksi Bangunan" 
              icon={<FaTreeCity />} 
              colors={["#ff6f00ff","#ff0073ff"]}
              description="Mewujudkan proyek konstruksi dengan standar tinggi, kokoh, dan sesuai kebutuhan Anda."
              link="/service#konstruksi"
              delay={.5}
              is_main={true}
            />
            <ServiceCard 
              title="Design Konstruksi" 
              icon={<FaPenRuler />} 
              colors={["green.600","#73f5a5ff"]}
              description="Merancang solusi desain yang fungsional, estetis, dan terencana secara profesional."
              link="/showroom"
              delay={1}
              is_main={false}
            />
          </Flex>
        </Box>
      </Box>

      {/* Projects Section (Carousel Placeholder) */}
      {/* <Box py={16} bg="#F0F4F8">
        <AnimatedComponent delay={0}>
          <Text 
            fontSize="4xl" 
            fontWeight="bold" 
            textAlign="center" 
            mb={8}
            color="#2C6E49"
          >
            Our Recent Projects
          </Text>
        </AnimatedComponent>
        <Grid 
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} 
          gap={8} 
          maxW="8xl" 
          mx="auto"
        >
          {[1, 2, 3].map((item) => (
            <ProjectCard 
              key={item} 
              image="https://source.unsplash.com/random/600x400/?construction" 
              title={`Project ${item}`} 
              location="Jakarta, Indonesia" 
            />
          ))}
        </Grid>
      </Box> */}

      {/* Call-to-Action */}
      <Box 
        py={16} 
        bg="#2C6E49" 
        color="white" 
        textAlign="center"
      >
        <Text fontSize="2xl" mb={4}>
          Sudah Siap Untuk Memulai Proyek ?
        </Text>
        <Button 
          size="lg" 
          bg="#4A90E2" 
          color="white" 
          _hover={{ bg: "#3B7DAA" }}
          asChild
        >
          <a href="https://wa.me/62882008354419">
            Kontak Kami Sekarang
          </a>
        </Button>
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
}

export default Home;